import type {SalesforceUserObject} from '@cohort/merchants/apps/salesforce/sync/utils';
import {
  getEmailFieldsFromObject,
  getSalesforceObjectByName,
} from '@cohort/merchants/apps/salesforce/sync/utils';
import SelectInput from '@cohort/merchants/components/form/select/SelectInput';
import type {SelectOption} from '@cohort/merchants/components/form/select/SelectPicker';
import {useCohortForm} from '@cohort/merchants/hooks/contexts/form';
import type {SyncConfigFormValues} from '@cohort/merchants/pages/apps/app/utils';
import {useTranslation} from 'react-i18next';

type ImportUsersEmailFieldSelectProps = {
  salesforceUserObjects: SalesforceUserObject[];
};
const ImportUsersEmailFieldSelect: React.FC<ImportUsersEmailFieldSelectProps> = ({
  salesforceUserObjects,
}) => {
  const {setValue, register, control, watch} =
    useCohortForm<Extract<SyncConfigFormValues, {appId: 'salesforce'}>>();

  const {t} = useTranslation('app-salesforce', {
    keyPrefix: 'sync.importUsersEmailFieldSelect',
  });

  const isImportEnabled = watch('userImportEnabled');
  const salesforceObjectName = watch('userSyncConfig.salesforceObjectName');

  const selectedObject = getSalesforceObjectByName(salesforceUserObjects, salesforceObjectName);

  const emailFieldOptions =
    selectedObject !== undefined
      ? getEmailFieldsFromObject(selectedObject).map(field => ({
          label: field.label,
          value: field.name,
        }))
      : [];

  const handleChange = (option: SelectOption | null): void => {
    if (option === null) {
      return;
    }

    setValue('userSyncConfig.emailFieldName', option.value.toString());
  };

  return (
    <SelectInput
      name="userSyncConfig.emailFieldName"
      placeholder={t('placeholder')}
      register={register}
      control={control}
      label={t('label')}
      options={emailFieldOptions}
      disabled={!isImportEnabled || selectedObject === undefined}
      onChange={handleChange}
    />
  );
};

export default ImportUsersEmailFieldSelect;
